    <template>
	<div v-if="raw && raw.data">
		<div class="ce-image">
			<figure>
				<img :src="$APIURL +'../files/images/header/Header-Rezepte.jpg'" alt title />
			</figure>
		</div>

		<div class="screen-wrapper">
			<div class="site-back-btn">
				<a onclick="history.back()" class="btn-go-back">Zurück</a>
				<span>
					<span></span>
					<span></span>
				</span>
			</div>
		</div>

		<section
			v-if="(!blnIsDetail && !blnIsRecipeDetail)"
		>{{blnIsDetail}} {{blnIsRecipeDetail}} Kategorie liste</section>

		<section v-else-if="((blnIsDetail && !blnIsRecipeDetail))" class="content-wrapper">
			<section
				v-if="objectdata"
				is="app-content-element-slider"
				type="Slider"
				:objectdata="objectdata"
			></section>

			<div v-if="raw.data && raw.data.attributes">
				<div>
					<article
						v-for="(item,index) in raw.data.attributes.recipes"
						:class="(index == 0) ? 'tile-teaser tile-teaser--big' : 'tile-teaser tile-teaser--small'"
						:key="'p' + index"
					>
						<figure>
							<img
								:src="item.teaserimage"
								:alt="item.title"
								:title="item.title"
								@click="gotoPage($route.path + '/' + item.alias)"
							/>
						</figure>
						<header>
							<h3 v-if="index == 0" @click="gotoPage($route.path + '/' + item.alias)">{{item.title}}</h3>
							<h4 v-else @click="gotoPage($route.path + '/' + item.alias)">{{item.title}}</h4>
							<p v-if="index == 0" v-html="item.description" />
							<a
								@click="gotoPage($route.path + '/' + item.alias)"
								:title="item.title"
								class="link"
								v-if="index == 0"
							>Mehr entdecken</a>
							<a
								@click="gotoPage($route.path + '/' + item.alias)"
								:title="item.title"
								class="btn btn-circle"
								v-else
							>
								<span>Mehr entdecken</span>
							</a>
						</header>
					</article>
				</div>
			</div>
		</section>
		<section v-else-if="blnIsDetail && blnIsRecipeDetail">
			<nav class="mod_subnavigation">
				<ul>
					<li
						v-for="(item,index) in raw.data.attributes.recipecategories"
						v-if="item && item.alias && (item.alias != parent && item.alias != current) "
						:key="'catlink' + index"
					>
						<a @click="gotoPage('/unsere-rezepte/' + item.alias)">{{item.title}}</a>
					</li>
				</ul>
			</nav>
			<section class="content-wrapper">
				<!-- Detail -->
				<h2 class="text-center">{{raw.data.attributes.title}}</h2>
				<p v-html="raw.data.attributes.description" />

				<div class="recipes-box">
					<img
						:src="raw.data.attributes.teaserimage"
						:alt="raw.data.attributes.title"
						:title="raw.data.attributes.title"
					/>
					<div class="recipes-description">
						<div>
							<h3>Zutaten</h3>

							<div
								v-for="(item,index) in raw.data.attributes.ingredients"
								:key="index"
								class="checkbox_container"
							>
								<input :id="'opt_' + index" type="checkbox" name="ingredient" :value="item" />
								<label :for="'opt_' + index">{{item}}</label>
							</div>
						</div>
						<div>
							<div class="ce-headline">
								<h3>Dazu passt:</h3>
							</div>
							<p
								v-html="raw.data.attributes.additionalheadline
								+'<br>'+
								raw.data.attributes.additionaltext"
							/>
							<img
								:src="raw.data.attributes.additionalimage"
								:alt="raw.data.attributes.additionalheadline"
								:title="raw.data.attributes.additionalheadline"
							/>
						</div>
						<a @click.prevent="print()" class="btn btn-circle">
							<span>Drucken</span>
						</a>
					</div>
				</div>
				<div class="recipes-info">
					<div class="recipes-info-box">
						<p
							v-html="'<span>Zubereitung</span><br><span>'+raw.data.attributes.infocookingtime+'</span>'"
						/>
					</div>
					<div class="recipes-info-box">
						<p v-html="'<span>Fertig in</span><br><span>'+raw.data.attributes.inforeadyin+'</span>'" />
					</div>
					<div class="recipes-info-box">
						<p v-html="'<span>Kalorien</span><br><span>'+raw.data.attributes.infocalorie+'</span>'" />
					</div>
					<div class="recipes-info-box">
						<p
							v-html="'<span>Schwierigkeit</span><br><span>'+raw.data.attributes.infodifficulty+'</span>'"
						/>
					</div>
				</div>
				<div class="ce-headline">
					<h3 class="text-center">Und so wirds gemacht</h3>
				</div>
				<div class="ce-slider slider-container" v-if="raw.data.attributes.steps">
					<hooper
						class="slider-wrapper"
						:infiniteScroll="true"
						:centerMode="true"
						:wheelControl="false"
						:mouseDrag="false"
						:transition="1200"
						@slide="nextSlideHeight"
						@afterSlide="checkPlayVideo"
						@loaded="checkSlider"
					>
						<slide
							class="slide-item slider-item--tile-teaser"
							v-for="(slide, index) in raw.data.attributes.steps"
							:key="index"
						>
							<article class="tile-teaser tile-teaser--big">
								<figure :style="'background-image:url('+slide.stepimage+')'">
									<img :src="slide.stepimage" />
								</figure>
								<header>
									<h2>{{slide.steptitle}}</h2>
									<div v-html="slide.steptext" />
								</header>
							</article>
						</slide>
						<div
							slot="hooper-addons"
							@click="$children[0].$children[0].$hooper.slidePrev()"
							class="slider-button slider-prev-button"
							style="display: block;"
						>
							<span></span>
						</div>
						<div
							slot="hooper-addons"
							@click="$children[0].$children[0].$hooper.slideNext()"
							class="slider-button slider-next-button"
							style="display: block;"
						>
							<span></span>
						</div>
						<!-- <hooper-navigation slot="hooper-addons"></hooper-navigation> -->
						<hooper-pagination slot="hooper-addons"></hooper-pagination>
					</hooper>
				</div>
				<div class="ce-headline">
					<h3 class="text-center">Was dich auch interessieren könnte</h3>
				</div>
				<article
					class="tile-teaser tile-teaser--small"
					v-for="(item,index) in raw.data.attributes.recommendedrecipes"
					:key="index"
				>
					<figure>
						<img :src="item.teaserimage" :alt="item.title" :title="item.title" />
					</figure>
					<header>
						<h4>{{item.title}}</h4>
						<a
							@click="gotoPage('/unsere-rezepte/'+$route.params.parent + '/' + item.alias)"
							:title="item.title"
							class="btn btn-circle"
						>
							<span>Mehr entdecken</span>
						</a>
					</header>
				</article>
			</section>
		</section>
	</div>
</template>
    <script>
	import Base from "./Base.vue";
	// import AppContentElementSlider from "./AppContentElementSlider";
	import {
		Hooper,
		Slide,
		Navigation as HooperNavigation,
		Pagination as HooperPagination
	} from "hooper";
	// import "hooper/dist/hooper.css";

	export default {
		components: {
			// AppContentElementSlider,
			Hooper,
			Slide,
			HooperNavigation,
			HooperPagination
		},
		extends: Base,
		data() {
			return {
				currentCategory: false,
				blnIsDetail: false,
				blnIsRecipeDetail: false,
				blnInitedJQ: false,
				objectdata: false,
				vueroutename: this.$route.params.current,
				apicomponentname:
					this.$route.path == "/unsere-rezepte" ||
					!this.$route.params.parent
						? "recipecategories"
						: "recipes"
			};
		},
		updated() {
			this.blnIsDetail = this.$route.path == "/unsere-rezepte" ? false : true;
			this.blnIsRecipeDetail = this.$route.params.parent ? true : false;
			this.checkPlayVideo();
		},
		created() {
			this.init();
		},
		methods: {
			init() {
				this.parent = this.$route.params.parent;
				this.current = this.$route.params.current;
				this.blnIsDetail =
					this.$route.path == "/unsere-rezepte" ? false : true;
				this.blnIsRecipeDetail = this.$route.params.parent ? true : false;
				this.getList();
			},
			print: function() {
				window.print();
			},
			postInit() {
				if (this.raw.data.length > 0) {
					let objParam = false;
					if (this.raw.data.attributes) {
						objParam = this.raw.data;
					} else {
						objParam = this.raw.data[0];
					}

					this.currentCategory =
						this.raw.data.length > 0 && objParam && objParam.attributes
							? objParam.attributes.alias
							: false;

					if (this.currentCategory) {
						this.$router.push(
							"/unsere-rezepte/" + this.currentCategory
						);
					}
				}
				this.ranInit = false;
				if (!this.blnInitedJQ) {
					this.blnInitedJQ = true;
				}
			}
		},
		watch: {
			$route(to, from) {
				this.objectdata = {};
				this.raw = {};
				this.apicomponentname =
					to.path == "/unsere-rezepte" || !to.params.parent
						? "recipecategories"
						: "recipes";
				this.init();
			}
		}
	};
</script>
<style lang="scss">
	@import "@/scss/variables.scss";
	@import "@/scss/mixins.scss";

	.recipes-box {
		margin-bottom: 30px;

		@include min-screen($screen-min-m) {
			margin-bottom: 60px;
		}

		img {
			display: block;
		}
	}

	.recipes-description {
		display: block;
		background: $color-white;
		margin-bottom: 40px;
		padding: 20px;
		position: relative;

		@include min-screen($screen-min-m) {
			display: flex;
		}

		> div {
			color: $color-green;

			&:nth-child(2) {
				img {
					max-width: 250px;
				}
			}

			@include min-screen($screen-min-m) {
				flex: 1;
			}
		}

		.btn.btn-circle {
			bottom: -15px;
			position: absolute;
			right: 15px;
		}
	}

	.recipes-info {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;

		@include min-screen($screen-min-m) {
			padding: 0 20px;
		}

		.recipes-info-box {
			border: 1px solid $color-green;
			text-align: center;
			margin-bottom: 15px;
			padding: 10px;
			flex: 1 48%;
			max-width: 48%;

			&:nth-child(even) {
				margin-left: 2%;
			}

			@include min-screen($screen-min-m) {
				flex: initial;
				width: 150px;
				max-width: 150px;

				&:nth-child(1n + 2) {
					margin-left: 2%;
				}
			}

			p {
				color: $color-green;
				line-height: 2;
				margin: 0;
				@include font-TheMix("bold");

				span {
					display: inline-block;
					line-height: 2;
					position: relative;

					&:nth-child(1) {
						&:after {
							border-bottom: 1px solid $color-green;
							bottom: 0;
							content: " ";
							height: 1px;
							left: 50%;
							position: absolute;
							transform: translateX(-50%);
							width: 90%;
						}
					}
				}
			}
		}
	}
</style>